import request from '@/utils/request'

const getCurrentUserTrainings = () => {
  return request({
    url: `${process.env.VUE_APP_AMAZON_API}/ShiXunGuanLi/GetCurrentUserTrainings`,
    method: 'get'
  })
}

const resetCurrentUserTraining = () => {
  return request({
    url: `${process.env.VUE_APP_AMAZON_API}/ShiXunGuanLi/ResetCurrentUserTraining`,
    method: 'post'
  })
} 

export default {
  getCurrentUserTrainings,
  resetCurrentUserTraining
}
